import { Component } from 'preact'
import SearchSelect from '../search-select'
import { __ } from '../../../locales'

class KeywordFilter extends Component {
    render({ keywords, fetchKeywords, required, onInputsChange, inputs }) {
        const decodedKeyword = inputs?.keyword ? decodeURIComponent(inputs.keyword) : null
        return (
            <SearchSelect
                required={required}
                title={__('inputs.keyword.label')}
                options={[{ value: null, label: __('global.none') }, ...keywords]}
                value={decodedKeyword ? { value: decodedKeyword, label: decodedKeyword } : null}
                onAutocompleteSearch={fetchKeywords}
                onChange={({ value }) => onInputsChange('keyword', value ? encodeURIComponent(value) : null)}
            />
        )
    }
}

export default KeywordFilter;
